import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-setting",
  style: {"margin-right":"4px"}
}, null, -1)

import { computed } from 'vue'
import { FormSizeType } from '@/components/cmForm/types'

export interface ColumnItem {
  key: string
  label: string
  defaultVisible?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    columns: {},
    modelValue: {},
    disabled: { type: Boolean },
    size: {},
    buttonText: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const visibleColumns = computed(() => props.modelValue)

const handleCheckboxChange = (key: string, value: boolean) => {
  const newValue = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newValue)
}

const handleCommand = (key: string) => {
  // 点击整行也能切换
  const currentValue = props.modelValue[key]
  const column = props.columns.find(c => c.key === key)
  if (column && !column.disabled) {
    handleCheckboxChange(key, !currentValue)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    disabled: _ctx.disabled,
    onCommand: handleCommand,
    "popper-class": "column-settings-dropdown"
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createBlock(_component_el_dropdown_item, {
              key: column.key,
              command: column.key,
              disabled: column.disabled
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  "model-value": visibleColumns.value[column.key],
                  disabled: column.disabled,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                  onChange: (val) => handleCheckboxChange(column.key, val)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(column.label), 1)
                  ]),
                  _: 2
                }, 1032, ["model-value", "disabled", "onChange"])
              ]),
              _: 2
            }, 1032, ["command", "disabled"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: _ctx.size,
        disabled: _ctx.disabled
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createTextVNode(" " + _toDisplayString(_ctx.buttonText), 1)
        ]),
        _: 1
      }, 8, ["size", "disabled"])
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})